import axios from 'axios';
import { HTABLE } from 'utils/constants';

const searchHtable = (hTable: string, searchValue: string, idDocType: number, idCompany: number) => {
  return axios.get<{ code: string; description: string }[]>(`${HTABLE}/searchHTable`, {
    params: { hTable, searchValue, idDocType, idCompany },
  });
};

export default {
  searchHtable,
};
